import React from "react";
import AllPageFooter from "../../../PreviewPdf/AllPageFooter";

const SummaryPage = React.memo(function SummaryPage({ reportData, pageNum, propLogo }) {
  const summaryData =
    reportData?.propertyInspectionReport?.doorComplianceSummary ?? {};

  return (
    <div className="page sheet">
      <div className="sumPg">
        <div className="sumHdr">
          <div className="sumHdrTitle">Summary</div>
          <div className="sumHdrRule" />
        </div>
        <div className="hero">
          <div className="heroTop">
            <div className="heroTopValue">
              {summaryData?.totalActionRequired ?? "-"}
            </div>
            <div className="heroTopLabel">Total Action Required</div>
          </div>
          <div className="heroDivider" />
          <div className="heroStats">
            <div className="heroStat">
              <div className="heroStatNum">
                {summaryData?.totalDoorsSurveyed ?? "-"}
              </div>
              <div className="heroStatCap">Total Door Surveyed</div>
            </div>
            <div className="heroStat">
              <div className="heroStatNum">
                {summaryData?.totalCompliantDoors ?? "-"}
              </div>
              <div className="heroStatCap">Total Compliant Doors</div>
            </div>
            <div className="heroStat">
              <div className="heroStatNum">
                {summaryData?.totalNonCompliantDoors ?? "-"}
              </div>
              <div className="heroStatCap">Total Non-Compliant Doors</div>
            </div>
          </div>
        </div>
        <div className="cards">
          <div className="tile tileUrgent">
            <div className="tileNum">
              {summaryData?.totalUrgentPriorityIssues ?? "-"}
            </div>
            <div className="tileCap">Total Urgent Priority Issues</div>
          </div>
          <div className="tile tileHigh">
            <div className="tileNum">
              {summaryData?.totalHighPriorityIssues ?? "-"}
            </div>
            <div className="tileCap">Total High Priority Issues</div>
          </div>
          <div className="tile tileMedium">
            <div className="tileNum">
              {summaryData?.totalMediumPriorityIssues ?? "-"}
            </div>
            <div className="tileCap">Total Medium Priority Issues</div>
          </div>
          <div className="tile tileLow">
            <div className="tileNum">
              {summaryData?.totalLowPriorityIssues ?? "-"}
            </div>
            <div className="tileCap">Total Low Priority Issues</div>
          </div>
        </div>
      </div>
      <AllPageFooter pageNumber={pageNum} propLogo={propLogo} />
    </div>
  );
});

export default SummaryPage;
